
import { defineComponent } from "vue";
import { toast } from "vue3-toastify";
import InfigoIframe from "@/components/iframe/index.vue";
import { ShoppingCartItem } from "@/types/iframe/infigo-job-response.type";
import ShoppingCartItemState from "@/services/cache/shopping-cart-item-state";
import InfigoLoading from "@/components/shared/loading.vue";
import Title from "@/components/layout/title.vue";
import {BasketItem} from "@/types/demo/basket-item";

export default defineComponent({
  components: {
    Title,
    InfigoIframe: InfigoIframe,
    InfigoLoading: InfigoLoading,
  },
  data() {
    return {
      loading: true, // Initially set loading to true
      canGoToBasket: false,
      openIframe: false,
      iframeProductId: null as number | null,
      jobId: null as string | null,
      products: [] as Array<{ id: number; name: string }>, // Store products here
    };
  },
  mounted() {
    const jobId = this.$route.params.id || null;

    if (!jobId) {
      toast("Job not found", { position: "top-right", type: "error" });
      this.$router.push("/shopping-list");
      return;
    }

    ShoppingCartItemState.loadCartFromLocalStorage();
    const items = ShoppingCartItemState.getCartItems();

    const item = items.find((it) => it.jobId == jobId);

    if (!item) {
      toast("Job not found in basket", {
        position: "top-right",
        type: "error",
      });
      this.$router.push("/shopping-list");
      return;
    }

    this.jobId = jobId.toString() || null;
    this.iframeProductId = item.productId;
    this.openIframe = true;
  },
  methods: {
    openIframeSubmit() {
      this.loading = true;
    },
    iframeLoaded() {
      this.loading = false;
    },
    addToBasket(item: BasketItem) {
      const existingItems = ShoppingCartItemState.loadCartFromLocalStorage();

      const index = existingItems.findIndex((it) => it.jobId == item.jobId);

      if (index < 0) {
        alert(`Failed to save item to basket - ${item.jobId}`);
        return;
      }

      ShoppingCartItemState.updateItem(index, item);
    },
  },
});
